/*
// Licensed Materials - Property of HCL
// (C) Copyright HCL Technologies Limited 2001, 2020
// All Rights Reserved
*/

export const CHART_COLORS = ['#AFE0F7', '#4B9ABF', '#264D60', '#AC96C8', '#7550A3', '#361B57', '#FAC08E', '#CC6C19', '#7A410F', '#94D6F4']
